/* eslint-disable */
export const MESSAGES = {
  NOT_FOUND: 'The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.',
  QUERY_ERROR: 'An error occurred while loading the page. Please check your network settings and try again.',
  COMMAND_ERROR: 'An error occurred while processing your request. Please check your network settings and try again.',
};
